module.exports = __webpack_public_path__ + "static/img/fish7.e8eef39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish7.png
// module id = 1q0x
// module chunks = 0